import {Trans} from '@lingui/macro';
import React from 'react';

import {
  VirtualTableColumnCellsEnum,
  virtualTableRowCheckboxWrapperWidth,
} from '../../../components/common/table/helpers/tableHelpers';
import {ApplicationModel} from '../../../models/api/applicationModel';
import {ResourceColumn, ResourceTableColumnTypesEnum} from '../commons/resourceTableTypes';

export enum ApplicationsTableColumnIdsEnum {
  NAME = 'name',
  CREATED_DATE = 'created_date',
}

export const applicationsTableColumns: ReadonlyArray<ResourceColumn<ApplicationModel>> = [
  {
    id: ApplicationsTableColumnIdsEnum.NAME,
    type: ResourceTableColumnTypesEnum.NAME,
    title: <Trans id="applications-table-column-name">Name</Trans>,
    accessor: (application) => application.name,
    iconName: 'integrationsFilledSmall',
    cellType: VirtualTableColumnCellsEnum.TEXT,
    settings: {
      sticky: {
        isSticky: true,
        stickyOffset: virtualTableRowCheckboxWrapperWidth,
      },
      cellWidth: {
        shouldFillRemainingWidth: true,
      },
    },
  },
];
